import {post} from '@/api'
const moduleUser={
    state: {
       tokens: {},
       currentIdCode: null
    },
    getters: {
        currentToken(state) {
          if (state.currentIdCode) {
              return state.tokens[state.currentIdCode];
          }else{
              return null;
          }
        }
    },
    mutations: {
        SET_TOKEN:(state,payload)=>{
            state.tokens[payload.idcode] = payload.token;
        },
        SET_CURRENT_ID_CODE(state, idcode) {
            state.currentIdCode = idcode;
        },
        LOG_OUT:(state)=>{
            state.tokens={}
            state.currentIdCode=null
        }
    },
    actions: {
        doLogin({commit},data){
            return new Promise((resolve,reject)=>{
                post("/login/doLogin",{username:data.username,password:data.password}).then((data)=>{
                    if(data.result.success){
                        commit("SET_CURRENT_ID_CODE",data.result.info.idcode)
                        commit("SET_TOKEN",{idcode:data.result.info.idcode,token:data.result.info.token})
                    }
                    resolve(data)
                }).catch((error)=>reject(error));
            }).catch(()=>{})
        },
        doMLogin({commit},data){
            return new Promise((resolve,reject)=>{
                post("/login/doMLogin",{mobile:data.mobile,code:data.code}).then((data)=>{
                    if(data.result.success){
                        commit("SET_CURRENT_ID_CODE",data.result.info.idcode)
                        commit("SET_TOKEN",{idcode:data.result.info.idcode,token:data.result.info.token})
                    }
                    resolve(data)
                }).catch((error)=>reject(error));
            }).catch(()=>{})
        },
        doLogout({commit}){
            return new Promise((resolve,reject)=>{
                post("/login/doLogout",{}).then(()=>{
                }).catch((error)=>reject(error));
                commit("LOG_OUT")
                resolve(1)
            }).catch(()=>{})
        }
    }
}

export default moduleUser